<script>
export default {
  name: 'RamadanBanner',
  props: {
    link: String,
    receiptLink: String
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    isRtl () {
      return this.locale === 'ar'
    }
  },
  methods: {
    openApp () {
      const qdAppLink = 'http://qic.online/l/ticket'
      window.open(qdAppLink)
    }
  }
}
</script>

<template>
  <div class="ramadan-banner">
    <div class="ramadan-banner-buttons">
      <a target="_blank" :href="link" class="ramadan-banner-buttons__element">
        <img src="./assets/file-download.svg" alt="file download">
        <span>{{ $t('qic_insurance_success_download_policy') }}</span>
      </a>
      <a
        v-if="receiptLink"
        target="_blank"
        :href="receiptLink"
        class="ramadan-banner-buttons__element"
      >
        <img src="./assets/receipt.svg" alt="receipt">
        <span>{{ $t('qic_insurance_receipt') }}</span>
      </a>
    </div>
    <div class="ramadan-banner-promo">
      <div class="ramadan-banner-promo__content">
        <img v-if="!isRtl" src="./assets/success-gift.png" alt="gift" class="ramadan-banner-promo__image" />
        <img v-if="isRtl" src="./assets/success-gift-ar.png" alt="gift" class="ramadan-banner-promo__image" />
        <img src="./assets/light-BG.png" alt="light" class="ramadan-banner-promo__light-bg">
        <p class="ramadan-banner-promo__title">{{ $t('ramadan.success_page.title') }}</p>
        <p class="ramadan-banner-promo__subtitle">{{ $t('ramadan.success_page.subtitle') }}</p>
        <img src="./assets/app-qr.svg" alt="qr code" class="ramadan-banner-promo__qr-code" />
        <span class="ramadan-banner-promo__scan">{{ $t('ramadan.success_page.scan') }}</span>
        <button class="ramadan-banner-promo__button" @click="openApp">
          {{ $t('ramadan.success_page.button.go_to_store') }}
        </button>
      </div>
      <div class="ramadan-banner-promo__background" />
    </div>
  </div>
</template>

<style lang="scss">
.insurance .ramadan-banner-buttons img {
  width: initial;
  margin: initial;
  display: initial;
  pointer-events: initial;
}
</style>

<style lang="scss" scoped>
.ramadan-banner {
  max-width: 464px;
  margin-inline: auto;
  margin-block-start: 40px;
}

.ramadan-banner-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-inline: auto;
  margin-bottom: 32px;
}

.ramadan-banner-buttons__element {
  border-radius: 12px;
  border: 1px solid #EBEBFF;
  padding: 16px;
  display: flex;
  justify-content: stretch;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.ramadan-banner-buttons__element:active {
  color: #6568F4;
}

.ramadan-banner-promo {
  position: relative;
  margin-inline: auto;
  border-radius: 32px;
  background: linear-gradient(36deg, #6568F4 5.76%, #DF7BE8 102.84%);
  overflow: hidden;
}

.ramadan-banner-promo__content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-block-start: 14px;
  padding-block-end: 40px;
  padding-inline: 32px;
  text-align: center;
  color: white;
}

.ramadan-banner-promo__background {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  background-image: url("./assets/background-light.svg");
  background-repeat: no-repeat;
  background-size: 93%;
  left: 53%;
  top: 0;
  transform: translateX(-50%);
  background-position-y: -22%;
  z-index: 1;
}

.ramadan-banner-promo__image {
  width: 213px;
  margin: initial;
  margin-inline-start: 10px;
  margin-block-end: -13px;
}

.ramadan-banner-promo__title {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  margin-block-end: 4px;
}

.ramadan-banner-promo__light-bg {
  position: absolute;
  top: 3%;
  width: 205px;
  left: 55%;
  transform: translateX(-50%);
  z-index: -1;
}

.ramadan-banner-promo__subtitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-block-end: 29px;
}

.ramadan-banner-promo__qr-code {
  width: initial;
  margin-block-end: 6px;
}

.ramadan-banner-promo__scan {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}

.ramadan-banner-promo__button {
  display: none;
}

@media (max-width: 550px)  {
  .ramadan-banner {
    max-width: 358px;
  }

  .ramadan-banner-promo__scan {
    display: none;
  }

  .ramadan-banner-promo__qr-code {
    display: none !important;
  }

  .ramadan-banner-promo__button {
    display: block;
    border-radius: 8px;
    border: 1px solid #E5E3FF;
    background: #FFF;
    padding-block: 12px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
  }
}

.rtl {
  .ramadan-banner-promo__background {
    transform: translateX(0%);
  }
}
</style>
